(() => {
  angular
    .module('gm.common.mobile', [])
    .factory('GmyMobileApp', GmyMobileApp);

  function GmyMobileApp(
    $window
  ) {
    'ngInject';

    return {
      isMobile,
      openExternal,
    };

    function isMobile() {
      return (('goldmoney' in $window)
        && ('isMobileApp' in $window.goldmoney)
        && ($window.goldmoney.isMobileApp));// _isMobileApp;
    }

    function openExternal(url) {
      $window.goldmoney.openExternal = url;
    }
  }
})();
